import React from "react";
import Hero from "./components/Hero";
import Features from "./components/Features";
import FeaturesSecond from "./components/FeaturesSecond";
import Testimonial from "./components/Testimonial";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Projects from "./components/Projects";
import ContactUs from "./components/ContactUs";
import AboutUs from "./components/AboutUs";
import Specialty from "./components/Specialty";

const App = () => {
  return (
    <div className="w-full max-w-[1440px] mx-auto bg-[#ECE8E5]">
      <Header />
      <Hero />
      <Features />
      <Specialty />
      <FeaturesSecond />
      <Projects />
      <AboutUs />
      <Testimonial />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default App;
